export interface TabMapOptions {
    enableShowStatusOption: boolean;
}

const defaultTabOptions: TabMapOptions = {
    enableShowStatusOption: true,
};

export { defaultTabOptions };
